// 英语(马来西亚)
export default {
  el: {
    select: {
      loading: 'Memuatkan',
      noMatch: 'Tiada data sepadan',
      noData: 'Tiada data',
      placeholder: 'Sila pilih',
    },
  },
  layout: {
    title: 'Sign In with Uniportal ID',
    tip: 'Nombor telefon bimbit yang tidak berdaftar akan didaftarkan secara automatik selepas berjaya log masuk',
    line: 'Pilihan Log Masuk Lain',
  },
  button: {
    submit: 'Log Masuk / Daftar',
    getCode: 'Dapatkan kod',
    emailRegister: 'Daftar dengan E-mel',
    w3Login: 'Log Masuk Akaun W3',
    employeeLogin: 'Log Masuk Pekerja',
    passwordLogin: 'log masuk kata laluan',
    reSend: 'Hantar semula',
    problem: 'Bantuan Dalam Talian',
    privacyPolicy: 'Kesihatan & Kesejahteraan',
  },
  placeholder: {
    phoneNumber: 'Nombor Telefon Bimbit',
    verificationCode: 'Kod pengesahan SMS',
  },
  dialog: {
    imgCode: 'Masukkan aksara pada imej.',
    userAgreements: {
      header: 'Perjanjian Pengguna dan Kenyataan Privasi',
      text1: 'Sila baca dan bersetuju dengan {privacy} dan {agreement}.',
      text2:
        'Maklumat peribadi akan dihantar kepada anak syarikat Huawei di luar negara untuk diproses apabila anda mengakses aplikasi Huawei di luar negara, seperti yang ditunjukkan dalam {privacy}',
    },
    crossBorder: {
      header: 'Petua kebenaran',
      text: 'Perkhidmatan tempatan yang anda gunakan tidak berada di kawasan yang sama dengan akaun anda didaftarkan. Kebenaran anda diperlukan untuk mengakses maklumat akaun merentas sempadan.',
    },
    multiAccounts: 'Pilih akaun.',
    agreeButton: 'Bersetuju dan Teruskan',
    disagreeButton: 'Tidak setuju',
    confirmButton: 'Pengesahan',
    cancelButton: 'Batal',
    knowMe: 'OK',
  },
  toast: {
    hasSend: 'Kod pengesahan dihantar.',
    wait: 'Tunggu sebentar',
  },
  tooltip: {
    Huawei: 'ID Huawei',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'Kod CAPTCHA tidak boleh dibiarkan kosong.',
    'IDC-03-0002': 'Kod CAPTCHA sudah tamat tempoh.',
    'IDC-00-0004': 'Kod CAPTCHA tidak betul.',

    // 表单输入为空
    'IDC-01-00024': 'Kod negara diperlukan untuk mengesahkan nombor telefon bimbit anda.',
    phoneNumberEmpty: 'Masukkan nombor telefon bimbit.',
    'IDC-03-00033': 'Masukkan kod pengesahan SMS.',

    // 表单数据错误
    'IDC-02-00227':
      'Nombor telefon bimbit yang dimasukkan tidak sepadan dengan negara yang dipilih',
    'IDC-02-00226': 'Kod negara dilarang',
    'IDC-02-00029': 'Kod pengesahan salah atau telah tamat tempoh',
    'IDC-02-0013': 'Log masuk SMS gagal. Kod pengesahan salah',
    'IDC-02-0020': 'Pengesahan gagal. Kod pengesahan tidak betul.',
    'IDC-02-00028': 'Nombor telefon bimbit mestilah nombor antara 6 hingga 30 digit',
    'IDC-02-00012': 'Nombor telefon bimbit salah',

    // 错误操作锁定
    accountLock:
      'Nombor telefon bimbit atau kod pengesahan tidak betul. Baki {number} cubaan. | Nombor telefon bimbit atau kod pengesahan tidak betul. Baki {number} cubaan.',
    accountLocked: 'Terlalu banyak cubaan yang gagal. Sila cuba lagi selepas {number} saat.',
    operationRisk:
      'Operasi semasa mempunyai risiko keselamatan. Sila cuba lagi dalam {number} saat.',

    // 频繁操作
    'IDC-02-00038': 'Cuba lagi selepas 60 saat.',
    'IDC-02-00064':
      'Anda telah menghantar kod pengesahan SMS terlalu kerap. Sila cuba lagi 24 jam kemudian.',
    'IDC-02-00211': 'Operasi semasa mempunyai risiko keselamatan. Sila cuba lagi kemudian.',
    'IDC-02-00212':
      'Bilangan kod pengesahan SMS yang dihantar oleh nombor telefon anda terlalu kerap. ' +
      'Sila ubah nombor telefon bimbit anda atau cuba lagi 24 jam kemudian.',
    'IDC-02-00213':
      'Anda telah menghantar kod pengesahan SMS terlalu kerap. Sila cuba lagi 24 jam kemudian.',
    'IDC-02-00215':
      'Bilangan kod pengesahan SMS yang dihantar oleh nombor telefon anda terlalu kerap. Sila cuba ubah nombor telefon bimbit atau pilih kaedah pengesahan lain, atau cuba lagi 24 jam kemudian.',
    'IDC-02-00228':
      'Anda telah menghantar kod pengesahan SMS terlalu kerap. Sila cuba lagi selepas 1 jam.',
    'IDC-02-00092': 'Operasi semasa terlalu kerap. Sila cuba lagi dalam masa 24 jam.',

    // 请求异常
    'IDC-10-00400': 'Permintaan pelanggan tidak normal',
    'IDC-10-00500': 'Ralat sistem dalaman ',
    'IDC-02-00264': 'Permintaan yang tidak dibenarkan untuk capaian',
    'IDC-02-00063': 'Parameter tidak sah',
    'IDC-03-0007': 'Operasi semasa berisiko dan tidak boleh didaftarkan buat sementara waktu.', // 机翻
    'IDC-03-00057': 'Operasi semasa mempunyai risiko keselamatan.',

    // 页面过期
    'IDC-00-00017': 'Halaman telah tamat tempoh.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Kembali',
  closeButton: 'Tutup',

  // 滑块验证相关：
  resourceReqFailed: 'Permintaan sumber gagal. Muat semula laman dan cuba lagi.',
  verifyFailedAndPlsRetry: 'Pengesahan gagal, sila cuba lagi',
  serviceErrAndPlsRetry: 'Excepción del servicio. Vuelva a intentarlo.',
  learnMore: 'Ketahui lebih lanjut',
  cookieBannerText:
    'Laman web ini menggunakan fungsi kuki untuk memberikan pengalaman pengguna yang terbaik kepada anda.',
};
